/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Network service
 */

namespace Application.Services {
    'use strict';

    import Bundle = Models.Bundle;
    import ImportedBundle = Models.ImportedBundle;

    /**
     * InventoryBundleService
     */
    export class InventoryBundleService {
        
        public static $name: string = "inventoryBundleService";
        public static $inject: string[] = ['backendService', 'vnoService', '$q'];

        private backendBaseUrl: string = window.backendUrl;
        private bundleServicePath: string = 'bundle/';
        private takeServicePath: string = 'take/';
        private tsProbeServicePath: string = 'tsprobe/bundle/';
        private backendUrl: string = this.backendBaseUrl + this.bundleServicePath;

        constructor(private backendService: BackendService) {
        }

        /**
         * Returns the list of all the existing bundles.
         * @returns the list of all the existing bundles.
         */
         public getAllBundles(): ng.IPromise<Bundle[]> {
            const url: string = this.backendUrl + '/all';
            return this.backendService
                .get(url)
                .then((result: ng.IHttpPromiseCallbackArg<Bundle[]>) => result.data);
        }

        /**
         * Creates a new bundle, and returns it.
         * @param newBundle 
         * @returns the new bundle.
         */
        public createBundle(newBundle: ImportedBundle): ng.IPromise<Bundle> {
            const url: string = this.backendUrl;
            return this.backendService
                .post(url, newBundle)
                .then((result: ng.IHttpPromiseCallbackArg<Bundle>) => result.data);
        }

        /**
         * Deletes a bundle and returns the staus of the API call.
         * @param bundleId 
         * @returns the status of the API call.
         */
        public deleteBundle(bundleId: number): ng.IPromise<number> {
            const url: string = this.backendUrl + bundleId;
            return this.backendService
                .delete(url)
                .then((result: ng.IHttpPromiseCallbackArg<any>) => result.status)
        }

        /**
         * Validates all bundle's connections before doing a take
         * @param bundleId 
         * @returns the status of the API call.
         */
        public validateBundleConnections(bundleId: number): ng.IPromise<number> {
            const url: string = this.backendBaseUrl +  this.takeServicePath + 'validateBundleConnections/' + bundleId;
            return this.backendService
                .post(url, null)
                .then((result: ng.IHttpPromiseCallbackArg<number>) => result)
                .catch(error => error);
        }

        /**
         * Drops all bundle's connections before doing a take
         * @param bundleId 
         * @returns the status of the API call.
         */
         public dropBundleConnections(bundleId: number): ng.IPromise<number> {
            const url: string = this.backendBaseUrl + this.takeServicePath + 'dropBundle/' + bundleId;
            return this.backendService
                .delete(url)
                .then((result: ng.IHttpPromiseCallbackArg<number>) => result.status)
                .catch(error => error);
        }

        /**
         * Performs a take for all bundle's connections before doing a take
         * @param bundleId 
         * @returns the response of the API call.
         */
         public takeBundleConnections(bundleId: number): ng.IPromise<any> {
            const url: string = this.backendBaseUrl +  this.takeServicePath + 'takeBundle/' + bundleId;
            return this.backendService
                .post(url, null)
                .then((result: ng.IHttpPromiseCallbackArg<any>) => result)
                .catch(error => error);
        }

        /**
         * Drops all bundle's connections.
         * @param bundleId 
         * @returns the response of the API call.
         */
         public dropAllBundleConnections(bundleId: number): ng.IPromise<any> {
            const url: string = this.backendBaseUrl +  this.takeServicePath + 'dropBundleAll/' + bundleId;
            return this.backendService
                .delete(url)
                .then((result: ng.IHttpPromiseCallbackArg<any>) => result)
                .catch(error => error);
        }

        /**
         * Performs probing for the bundle
         * @param bundleId 
         * @returns the status of the API call.
         */
         public probeBundle(bundleId: number): ng.IPromise<any> {
            const url: string = this.backendBaseUrl + this.tsProbeServicePath + bundleId;
            return this.backendService
                .post(url, null)
                .then((result: ng.IHttpPromiseCallbackArg<number>) => result.status)
                .catch(error => error.status);
        }

        /**
         * Stops all the probing for the bundle
         * @param bundleId 
         * @returns the status of the API call.
         */
         public stopProbes(bundleId: number): ng.IPromise<number> {
            const url: string = this.backendBaseUrl + this.tsProbeServicePath + bundleId;
            return this.backendService
                .delete(url)
                .then((result: ng.IHttpPromiseCallbackArg<number>) => result.status)
                .catch(error => error.status);
        }
    }
}